import { UseFormRegister, FieldErrors } from "react-hook-form";
import styled from "styled-components";
import { ErrorMessage, FormGroup, Label } from "../../../components/common/Form";
import type { CourseType } from "../../../types/course";
import { InfoBox, InfoLabel, InfoValue } from "./ReadOnlyInfo";

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

const RadioOption = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: border-color 0.2s, background-color 0.2s;

  &:hover {
    border-color: #999;
    background-color: #fafafa;
  }

  &:has(input:checked) {
    border-color: #4caf50;
    background-color: #f0fff0;
  }
`;

const RadioInput = styled.input`
  margin-top: 3px;
  accent-color: #4caf50;
`;

const RadioContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const RadioTitle = styled.span`
  font-weight: 600;
  font-size: 15px;
  color: #333;
`;

const RadioDescription = styled.span`
  font-size: 13px;
  color: #666;
  margin-top: 2px;
`;

type FormInputs = {
  type: CourseType;
  level: string;
  companion_id: string;
};

type Props = {
  isReadOnly: boolean;
  currentLevel?: number;
  register: UseFormRegister<FormInputs>;
  errors: FieldErrors<FormInputs>;
};

const LEVELS = [
  {
    value: "1",
    title: "Livello 1",
    description:
      "Non ho mai sciato - ho fatto una lezione - devo imparare a frenare",
  },
  {
    value: "2",
    title: "Livello 2",
    description: "Faccio le curve - ho già fatto le piste blu",
  },
  {
    value: "3",
    title: "Livello 3",
    description: "Ho sicurezza in diversi ambienti - faccio le piste rosse",
  },
  {
    value: "4",
    title: "Livello 4",
    description: "Piena competenza sugli sci in qualunque situazione",
  },
];

export const LevelField = ({
  isReadOnly,
  currentLevel,
  register,
  errors,
}: Props) => {
  if (isReadOnly && currentLevel) {
    const levelInfo = LEVELS.find((l) => l.value === String(currentLevel));
    return (
      <InfoBox>
        <InfoLabel>Livello</InfoLabel>
        <InfoValue>
          {levelInfo ? `${levelInfo.title} - ${levelInfo.description}` : `Livello ${currentLevel}`}
        </InfoValue>
      </InfoBox>
    );
  }

  return (
    <FormGroup>
      <Label>Livello</Label>
      <RadioGroup>
        {LEVELS.map((level) => (
          <RadioOption key={level.value}>
            <RadioInput
              type="radio"
              value={level.value}
              {...register("level", { required: "Seleziona il livello" })}
            />
            <RadioContent>
              <RadioTitle>{level.title}</RadioTitle>
              <RadioDescription>{level.description}</RadioDescription>
            </RadioContent>
          </RadioOption>
        ))}
      </RadioGroup>
      {errors.level && <ErrorMessage>{errors.level.message}</ErrorMessage>}
    </FormGroup>
  );
};
